module.exports = __webpack_public_path__ + "static/media/nilfgaardBorder.a24e7f2e.png";